import React from 'react';
import './styles.css';

function Timeline2({ events }) {
  return (
    <div className="tl2-wrapper">
      {/* The horizontal line (desktop) is drawn via CSS on tl2-track */}
      <div className="tl2-track" aria-hidden="true" />

      <div className="tl2-events">
        {events.map((event, index) => {
          const isAbove = index % 2 === 0;
          return (
            <div key={index} className="tl2-event">
              {/* Area above the dot */}
              <div className="tl2-area tl2-area--above">
                {isAbove && (
                  <div className="tl2-content">
                    <div className="tl2-icon">{event.icon}</div>
                    <span className="tl2-time">{event.time}</span>
                    <span className="tl2-title">{event.title}</span>
                  </div>
                )}
              </div>

              {/* Dot on the line */}
              <div className="tl2-dot" />

              {/* Area below the dot */}
              <div className="tl2-area tl2-area--below">
                {!isAbove && (
                  <div className="tl2-content">
                    <div className="tl2-icon">{event.icon}</div>
                    <span className="tl2-time">{event.time}</span>
                    <span className="tl2-title">{event.title}</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Timeline2;
